import type {SketchArcObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SingleTargetRelation} from '../SingleTargetRelation';

let count = 0;
const MIN_RADIUS = 1e-8;

/**
 * 判断对象是否为圆弧半径关系。
 * @param value 待判断对象。
 * @returns 是否为圆弧半径关系。
 */
export function isArcRadiusConstraint(value: object): value is ArcRadiusConstraint {
    return Reflect.get(value, 'isArcRadiusConstraint') === true;
}

/**
 * 圆弧半径关系定义。
 *
 * 锁定值是关系领域的唯一数值事实，几何计算由统一参数公式完成。
 */
export class ArcRadiusConstraint extends SingleTargetRelation<SketchArcObject> {
    /** 运行时类型标记。 */
    public readonly isArcRadiusConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Radius;
    /** 锁定半径。 */
    private lockedRadius: number | null = null;

    /**
     * @param radius 锁定半径；未提供时保持未锁定并由创建方拒绝或补齐。
     */
    public constructor(radius?: number) {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
        if (typeof radius === 'number') {
            this.setLockedRadius(radius);
        }
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '半径';
    }

    /** @returns 锁定半径；未锁定返回 null。 */
    public getLockedRadius(): number | null {
        return this.lockedRadius;
    }

    /**
     * 设置锁定半径。
     * @param radius 新半径。
     */
    public setLockedRadius(radius: number): void {
        if (!Number.isFinite(radius) || radius <= MIN_RADIUS) {
            return;
        }
        this.lockedRadius = radius;
    }
}
